import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Include Both Helper File with needed methods
import {

	getReportList as getReportListApi,
	getReport as getReportApi,
	addNewReport as addNewReportApi,
	updateReport as updateReportApi,
	deleteReport as deleteReportApi,
} from '../../helpers/reports/backend_helper';


// Report actions
export const getReportList = createAsyncThunk('report/getReportList', async () => {
	try {
		const response = getReportListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getReport = createAsyncThunk('report/getReport', async (report_id) => {
	try {
		const response = getReportApi(report_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewReport = createAsyncThunk('report/addNewReport', async (report) => {
	try {
		const response = addNewReportApi(report);
		toast.success('Reporte agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar report.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateReport = createAsyncThunk('report/updateReport', async (report) => {
	try {
		const response = updateReportApi(report);
		toast.success('Reporte actualizado exitosamente', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al actualizar report.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const deleteReport = createAsyncThunk('report/deleteReport', async (report) => {
	try {
		const response = await deleteReportApi(report);
		toast.success('Reporte eliminado exitosamente.', { autoClose: 3000 });
		return { report, ...response };
	} catch (error) {
		toast.error('Error al eliminar report.', { autoClose: 3000 });
		throw new Error(error);
	}
});
